import React from 'react';
import { object, func } from 'prop-types';
import hasHoc from 'util/hoc/has-hoc';
import Query from 'apps/admin/util/query';
import { resolve } from 'library/helpers/path-resolver';
import useForm from 'library/hooks/use-form';
import * as Styled from 'apps/admin/pages/onboarding-steps/styles';
import { jsonToInputParams } from 'library/util/graph';
import { NotificationRender } from 'library/components/notification';

const OnboardingStepForm = ({
  graph_data = {},
  graph_loading,
  handle_graph_loading,
  reloadParentGraph = () => {},
  history,
  ...props
}) => {
  if(graph_loading) return handle_graph_loading();
  const onboardingStep = resolve(graph_data, 'onboarding_step', {});
  const { values, handleChange } = useForm(onboardingStep);
  const id = resolve(props, 'match/params/id', null);

  const handleSubmit = async () => {
    const mutationType = values.id ? 'update' : 'create';
    const params = jsonToInputParams({...values});
    let success = false;
    try {
    const { data } = await Query(`
      mutation {
        submit_step:${mutationType}_onboarding_step(
          ${params}
        ) {
          success
          errors
        }
      }`);
      success = resolve(data, 'submit_step/success', false);
    } catch(e) {
      console.error(e);
    };
    if (success) {
      NotificationRender('success', `steps was successfully ${values.id ? 'updated' : 'created'}`);
      history.push('/admin/onboarding-steps');
    } else {
      NotificationRender('error', 'There was an error');
    }
  };

  return (
    <Styled.FormWrapper>
      <h1>
        {values.id
          ? `OnboardingStep: ${values.title} (id: ${values.id})`
          : `New OnboardingStep`}
      </h1>

      <Styled.FormRow>
        <label>
          Set Key
          <input name="set_key" value={values.set_key} onChange={handleChange}>
          </input>
        </label>
      </Styled.FormRow>

      <Styled.FormRow>
        <label>
          Title
          <input name="title" value={values.title} onChange={handleChange}>
          </input>
        </label>
      </Styled.FormRow>

      <Styled.FormRow>
        <label>
          Target
          <input name="target" value={values.target} onChange={handleChange}>
          </input>
        </label>
      </Styled.FormRow>

      <Styled.FormRow>
        <label>
          Message
          <textarea name="message" value={values.message} onChange={handleChange}>
          </textarea>
        </label>
      </Styled.FormRow>

      <Styled.FormRow>
        <label>
          Card Config
          <input name="card_config" value={values.card_config} onChange={handleChange}>
          </input>
        </label>
      </Styled.FormRow>

      <button onClick={handleSubmit}>Submit</button>
    </Styled.FormWrapper>
  );
};

OnboardingStepForm.propTypes = {
  graph_data: object,
  reloadParentGraph: func,
  history: {
    push: func
  },
};

OnboardingStepForm.query = async (token, props) => {
  const id = resolve(props, 'match/params/id', null);
  let graph_data = {};
  try {
    graph_data = await Query(`{
      onboarding_step(id: ${id}) {
        id

        set_key
        title
        target
        message
        card_config
        # add other fields to query for here
      }
    }`);
  } catch (e) {
    console.error(e);
  }
  return graph_data;


}

OnboardingStepForm.hoc_list = ['withData', 'withReloadParent'];

export default hasHoc(OnboardingStepForm);
